const styles = {
  baseStyle: {
    borderRadius: "xl",
    py: "5.5px",
    px: 3,
  },
}

export default styles
